"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _get = require('lodash/get');
/**
 * @class SymbolizerUtil
 */
var FilterUtil = /** @class */ (function () {
    function FilterUtil() {
    }
    /**
     * Calculates the number of features that are covered by more then one rule per
     * rule.
     *
     * @param {object} matches An object containing the count of matches for every
     *  filter. Seperate by scales.
     * @returns {number[]} An array containing the number of duplicates for each
     *  rule.
     */
    FilterUtil.calculateDuplicates = function (matches) {
        var duplicates = [];
        var ids = [];
        matches.forEach(function (features, index) {
            var idMap = {};
            features.forEach(function (feat) { return idMap[feat.id] = true; });
            ids[index] = idMap;
        });
        matches.forEach(function (features, index) {
            var counter = 0;
            ids.forEach(function (idMap, idIndex) {
                if (index !== idIndex) {
                    features.forEach(function (feat) {
                        if (idMap[feat.id]) {
                            ++counter;
                        }
                    });
                }
            });
            duplicates[index] = counter;
        });
        return duplicates;
    };
    /**
     * Calculates the amount of matched and duplicate matched features for the rules.
     *
     * @param {Rule[]} rules An array of GeoStyler rule objects.
     * @param {VectorData} data A geostyler data object.
     * @returns {CountResult} An object containing array with the amount of matched
     * and duplicate matched features reachable through keys'counts' and 'duplicates'.
     */
    FilterUtil.calculateCountAndDuplicates = function (rules, data) {
        if (!rules || !data) {
            return {};
        }
        var result = {
            counts: [],
            duplicates: []
        };
        // Add id to feature if missing
        data.exampleFeatures.features = data.exampleFeatures.features.map(function (feature, idx) {
            if (!feature.id) {
                feature.id = idx;
            }
            return feature;
        });
        var matches = [];
        rules.forEach(function (rule, index) {
            var currentMatches = rule.filter ? FilterUtil.getMatches(rule.filter, data) : data.exampleFeatures.features;
            result.counts.push(currentMatches.length);
            matches[index] = currentMatches;
        });
        result.duplicates = FilterUtil.calculateDuplicates(matches);
        return result;
    };
    FilterUtil.nestingOperators = ['&&', '||', '!'];
    /**
     * Handle nested filters.
     */
    FilterUtil.handleNestedFilter = function (filter, feature) {
        switch (filter[0]) {
            case '&&':
                var intermediate_1 = true;
                var restFilter = filter.slice(1);
                restFilter.forEach(function (f) {
                    if (!FilterUtil.featureMatchesFilter(f, feature)) {
                        intermediate_1 = false;
                    }
                });
                return intermediate_1;
            case '||':
                intermediate_1 = false;
                restFilter = filter.slice(1);
                restFilter.forEach(function (f) {
                    if (FilterUtil.featureMatchesFilter(f, feature)) {
                        intermediate_1 = true;
                    }
                });
                return intermediate_1;
            case '!':
                return !FilterUtil.featureMatchesFilter(filter[1], feature);
            default:
                throw new Error("Cannot parse Filter. Unknown combination or negation operator.");
        }
    };
    /**
     * Handle simple filters, i.e. non-nested filters.
     */
    FilterUtil.handleSimpleFilter = function (filter, feature) {
        var featureValue = _get(feature, 'properties[' + filter[1] + ']');
        var filterValue = filter[2];
        switch (filter[0]) {
            case '==':
                return (('' + featureValue) === ('' + filterValue));
            case '*=':
                if (featureValue && filterValue.length > featureValue.length) {
                    return false;
                }
                else if (featureValue) {
                    return (featureValue.indexOf(filterValue) !== -1);
                }
                else {
                    return false;
                }
            case '!=':
                return (('' + featureValue) !== ('' + filterValue));
            case '<':
                return (parseFloat(featureValue) < parseFloat(filterValue));
            case '<=':
                return (parseFloat(featureValue) <= parseFloat(filterValue));
            case '>':
                return (parseFloat(featureValue) > parseFloat(filterValue));
            case '>=':
                return (parseFloat(featureValue) >= parseFloat(filterValue));
            default:
                throw new Error("Cannot parse Filter. Unknown comparison operator.");
        }
    };
    /**
     * Checks if a feature matches the specified filter.
     * Returns true if it matches, otherwise returns false.
     */
    FilterUtil.featureMatchesFilter = function (filter, feature) {
        if (filter.length === 0) {
            return true;
        }
        var matchesFilter = true;
        var operator = filter[0];
        var isNestedFilter = FilterUtil.nestingOperators.includes(operator);
        if (isNestedFilter) {
            matchesFilter = FilterUtil.handleNestedFilter(filter, feature);
        }
        else {
            matchesFilter = FilterUtil.handleSimpleFilter(filter, feature);
        }
        return matchesFilter;
    };
    /**
     * Returns those features that match a given filter.
     * If no feature matches, returns an empty array.
     *
     * @param {Filter} filter A geostyler filter object.
     * @param {VectorData} data A geostyler data object.
     * @return {Feature[]} An Array of geojson feature objects.
     */
    FilterUtil.getMatches = function (filter, data) {
        var matches = [];
        data.exampleFeatures.features.forEach(function (feature) {
            var match = FilterUtil.featureMatchesFilter(filter, feature);
            if (match) {
                matches.push(feature);
            }
        });
        return matches;
    };
    return FilterUtil;
}());
exports.default = FilterUtil;
//# sourceMappingURL=FilterUtil.js.map